export default __webpack_public_path__ + "static/media/platforma_konsultimit.99e3c216.png";